import React, { useEffect, useMemo } from 'react';
import {
  ListItem, ListItemText, TableRow, TableCell
} from '@material-ui/core';
import { compose } from 'recompose';
// import { GridSubmitAction } from '@ctsu/ctsu-mui-grid';
import { MUISelect } from 'components/FormHelpers/FormInputs';
import { useCtxParseValue } from 'helpers';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { FasSave, FasTimes, FasUndoAlt } from 'assets/icons';
import { CountrySelector, SiteSelector } from 'containers/protocol/components';
import { withChangeHandlers } from 'helpers/Change';
import { useSelector } from 'react-redux';

export const RegType = ({
  registrationType, handleChange, psrRegType, isRegTypeEditable
}) => {
  // PROT-141 Modify PSR Affiliation & Verification Grid Registration Type LOV to support NINT Changes
  const isNonIndNonTreat = useSelector(s => s.prtDetails?.prtInfo?.isNonIndNonTreat);
  const selectables = useMemo(() => {
    if (!isNonIndNonTreat) {
      return psrRegType.filter(f => !f.REG_TYPE_CD.includes('NINT'))
    } 
    return psrRegType;
  }, [isNonIndNonTreat, psrRegType]);
    return (
    <MUISelect
      value={registrationType || ''}
      name="registrationType"
      onChange={handleChange}
      // validators={!isRegTypeEditable ? ['required'] : []}
      // errorMessages={['Required Field']}
      disabled={isRegTypeEditable}
      title="Registration Type"
    >
      {_.map(selectables, (item, i) => (
        <ListItem
          button
          key={item.REG_TYPE_CD}
          value={item.REG_TYPE_CD}
        >
          <ListItemText
            primary={item.REG_TYPE_CD}
            secondary={item.DESCRIPTION}
          />
        </ListItem>
      ))}
    </MUISelect>
  )
};

export const RosterOwner = ({
  rosterOwner, handleChange, psrRosterOwner, isRostOwnerEditable
}) => (
  <MUISelect
    value={rosterOwner || ''}
    name="rosterOwner"
    // validators={!isRostOwnerEditable ? ['required'] : []}
    // errorMessages={['Required Field']}
    onChange={handleChange}
    disabled={isRostOwnerEditable}
    title="Roster Owner"
  >
    {_.map(psrRosterOwner, (item, i) => (
      <ListItem
        key={_.uniqueId('psr_roster_owner_sel')}
        button
        value={item.id}
      >
        <ListItemText
          primary={item.id}
          secondary={item.name}
        />
      </ListItem>
    ))}
  </MUISelect>
);


export const IRBType = ({
  irbType, handleChange, isIrbTypeEditable
}) => (
  <MUISelect
    value={irbType || ''}
    name="irbType"
    // validators={!isIrbTypeEditable ? ['required'] : []}
    // errorMessages={['Required Field']}
    onChange={handleChange}
    disabled={isIrbTypeEditable}
    title="IRBType"
  >
    {_.map(['CIRB', 'LOCAL'], (item) => (
      <ListItem
        key={_.uniqueId('psrirbType_sel')}
        button
        value={item}
      >
        <ListItemText
          primary={item}
          secondary={item}
        />
      </ListItem>
    ))}
  </MUISelect>
);

export const Country = ({
  handleCountryChange, countryCode, isCountryEditable, verifiedBy
}) => (
  <CountrySelector
    name="countryCode"
    onChanged={handleCountryChange}
    validators={verifiedBy === 'MANUAL' && ['required']}
    errorMessages={verifiedBy === 'MANUAL' && ['Required Field']}
    selCountry={countryCode || ''}
    isDisabled={isCountryEditable}
  />
);

export const Site = ({
  siteCtepId, handleSiteChange, isCtepIdEditable
}) => (
  <SiteSelector
    name="siteCtepId"
    onChanged={handleSiteChange}
    // validators={['required']}
    // errorMessages={['Required Field']}
    selSite={siteCtepId || ''}
    isDisabled={isCtepIdEditable}
  />
);

function EditSplReq(props) {
  const {
    state,
    handleChange,
    handleCountryChange,
    handleSiteChange,
    cancel,
    reset,
    save,
    verifiedBy,
    defaultRow,
    setState,
    isNewpsr,
    disableCreate
  } = props;

  useEffect(() => {
    setState({ ...defaultRow });
    if (isNewpsr) {
      disableCreate(true);
    }
    // eslint-disable-next-line
  }, [verifiedBy])

  let isRegTypeEditable = true;
  let isRostOwnerEditable = true;
  let isIrbTypeEditable = true;
  let isCountryEditable = true;
  let isCtepIdEditable = true;

  if (verifiedBy) {
    switch (verifiedBy) {
      case 'MANUAL':
        isCountryEditable = false;
        isRostOwnerEditable = false;
        isCtepIdEditable = false;
        isIrbTypeEditable = false;
        break;
      case 'PERSON_ATTRIBUTE':
        isRegTypeEditable = false;
        break;
      case 'INSTITUTION_ATTRIBUTE':
        isCountryEditable = false;
        isRostOwnerEditable = false;
        isCtepIdEditable = false;
        isIrbTypeEditable = false;
        break;
      case 'INTERNATIONAL':
        isCountryEditable = false;
        isRostOwnerEditable = false;
        isCtepIdEditable = false;
        break;
      default:
        break;
    }
  }

  const {
    registrationType,
    rosterOwner,
    irbType,
    countryCode,
    siteCtepId
  } = state;
  const { protocolPSRRegType } = useCtxParseValue('LOV_PSR_REG_TYPE');
  const { protocolPSRRosterOwner } = useCtxParseValue('LOV_PSR_ROSTER_OWNER');

  return (
    <TableRow className="state">
      <TableCell>
        <RegType
          registrationType={registrationType}
          psrRegType={protocolPSRRegType}
          handleChange={handleChange}
          isRegTypeEditable={isRegTypeEditable}
        />
      </TableCell>
      <TableCell>
        <RosterOwner
          rosterOwner={rosterOwner}
          psrRosterOwner={protocolPSRRosterOwner}
          handleChange={handleChange}
          isRostOwnerEditable={isRostOwnerEditable}
        />
      </TableCell>
      <TableCell>
        <IRBType
          irbType={irbType}
          handleChange={handleChange}
          isIrbTypeEditable={isIrbTypeEditable}
        />
      </TableCell>
      <TableCell>
        <Country
          countryCode={countryCode}
          handleCountryChange={handleCountryChange}
          isCountryEditable={isCountryEditable}
          verifiedBy={verifiedBy}
        />
      </TableCell>
      <TableCell>
        <Site
          handleSiteChange={handleSiteChange}
          siteCtepId={siteCtepId}
          isCtepIdEditable={isCtepIdEditable}
        />
      </TableCell>
      <TableCell>
        <span className="action-icon-container whiteSpace-nowrap">
          <button
            onClick={save}
            type="button"
            className="fn-btn font-lg mr-1"
            title="Save"
          >
            <FasSave />
          </button>
          <button
            onClick={() => {
              if(isNewpsr){
                disableCreate(false);
              }
              cancel(props);
            }}
            type="button"
            className="fn-btn font-lg mr-1"
            title="Cancel"
          >
            <FasTimes />
          </button>
          <button
            onClick={reset}
            type="button"
            className="fn-btn font-lg mr-1"
            title="Reset"
          >
            <FasUndoAlt />
          </button>
        </span>
      </TableCell>
    </TableRow>

  );
}

const EditSpecialRequirement = compose(withChangeHandlers)(EditSplReq);

EditSpecialRequirement.propTypes = {
  state: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  setEditing: PropTypes.bool.isRequired,
  verifiedBy: PropTypes.string.isRequired,
  setState: PropTypes.func.isRequired
};

export default EditSpecialRequirement;
